import { render, staticRenderFns } from "./SearchCustomers.vue?vue&type=template&id=fac06b20&scoped=true"
import script from "./SearchCustomers.vue?vue&type=script&lang=js"
export * from "./SearchCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac06b20",
  null
  
)

export default component.exports